<template>
  <div class="component-container">
    <button @click.prevent="fetchUnitList">Fetch Unit List - if you see this tell Michelle - Don't Click</button>
    <button @click.prevent="updateUnits">Update Unit List - if you see this tell Michelle - Don't Click</button>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebase')

export default {
  data() {
    return {
      fetchedUnits: []
    }
  },
  methods: {
    fetchUnitList() {
      fb.unitsCollection.get().then((snap) => {
        snap.forEach((doc) => {
          this.fetchedUnits.push({
            id: doc.id
          })
        })
      }).then(() => {
        console.log(this.fetchedUnits)
      }).catch((err) => {
        console.log(err)
      })
    },
    updateUnits() {
      this.fetchedUnits.forEach((unit) => {
        fb.unitsCollection.doc(unit.id).update({
          purchased: false
        }).then(() => {
          console.log(unit.id, 'has been updated')
        }).catch((err) => {
          console.log(err)
        })
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
